/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetSubscriptionQueryResponse, GetSubscriptionPathParams, GetSubscription400, GetSubscription401, GetSubscription403, GetSubscription404, GetSubscription409, GetSubscription500 } from "../../types/platformBillingController/GetSubscription.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSubscription } from "../../client/platformBillingController/getSubscription.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSubscriptionQueryKey = (organizationId: GetSubscriptionPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/platform-billing/subscription', params: {organizationId:organizationId} }] as const

export type GetSubscriptionQueryKey = ReturnType<typeof getSubscriptionQueryKey>

export function getSubscriptionQueryOptions(organizationId: GetSubscriptionPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSubscriptionQueryKey(organizationId)
        return queryOptions<GetSubscriptionQueryResponse, ResponseErrorConfig<GetSubscription400 | GetSubscription401 | GetSubscription403 | GetSubscription404 | GetSubscription409 | GetSubscription500>, GetSubscriptionQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getSubscription(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get current subscription
 * {@link /api/organizations/:organizationId/platform-billing/subscription}
 */
export function useGetSubscription<TData = GetSubscriptionQueryResponse, TQueryData = GetSubscriptionQueryResponse, TQueryKey extends QueryKey = GetSubscriptionQueryKey>(organizationId: GetSubscriptionPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetSubscriptionQueryResponse, ResponseErrorConfig<GetSubscription400 | GetSubscription401 | GetSubscription403 | GetSubscription404 | GetSubscription409 | GetSubscription500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getSubscriptionQueryKey(organizationId)
         

         const query = useQuery({
          ...getSubscriptionQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetSubscription400 | GetSubscription401 | GetSubscription403 | GetSubscription404 | GetSubscription409 | GetSubscription500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}